module.exports = __webpack_public_path__ + "static/3-70378cc3e440afb294fc13050fb77ea4.png";